/**
 * @public
 */
export class ManifestNormalizer {
  normalize(manifest: any): any {
    return manifest
  }
}
